const initialState = () => ({
  defaultIcon: 'card.png',
  cardIconMap: [
    {
      stripeName: 'visa',
      icon: 'visa.png',
    },
    {
      stripeName: 'mastercard',
      icon: 'mastercard.png',
    },
    {
      stripeName: 'amex',
      icon: 'amex.png',
    },
    {
      stripeName: 'maestro',
      icon: 'maestro.png',
    },
    {
      stripeName: 'diners',
      icon: 'dinersclub.png',
    },
    {
      stripeName: 'discover',
      icon: 'discover.png',
    },
    {
      stripeName: 'cirrus',
      icon: 'cirrus.png',
    },
    {
      stripeName: 'jcb',
      icon: 'jcb.png',
    },
    {
      stripeName: 'unionpay',
      icon: 'unionpay.png',
    },
  ],
});

export default {
  namespaced: true,
  state: () => initialState(),
  getters: {
    cardIcon: (state) => (name) => {
      for (let i = 0; i < state.cardIconMap.length; i += 1) {
        if (state.cardIconMap[i].stripeName === name) {
          return state.cardIconMap[i].icon;
        }
      }
      return state.defaultIcon;
    },
  },
};
